// eslint-disable-next-line no-magic-numbers
const scholarshipStatusIdList = [0, 1, 2, 3] as const;

// 奨学金借入状況
export type ScholarshipStatusId = (typeof scholarshipStatusIdList)[number];

export const isScholarshipStatusId = (
  value: unknown,
): value is ScholarshipStatusId => {
  if (typeof value !== 'number') {
    return false;
  }

  // eslint-disable-next-line no-magic-numbers
  if (value === 0) {
    return false;
  }

  return scholarshipStatusIdList.includes(value as ScholarshipStatusId);
};

const scholarshipStatusLabelList = [
  '----',
  '借りている',
  '借りる予定',
  '借りていた',
] as const;

type ScholarshipStatusLabel = (typeof scholarshipStatusLabelList)[number];

type ScholarshipStatus = {
  id: ScholarshipStatusId;
  label: ScholarshipStatusLabel;
};

export const scholarshipStatusList: ScholarshipStatus[] =
  scholarshipStatusIdList.map((value) => ({
    id: value,
    label: scholarshipStatusLabelList[value],
  }));

// eslint-disable-next-line no-magic-numbers, prefer-destructuring
export const defaultScholarshipStatus = scholarshipStatusList[0];

// eslint-disable-next-line no-magic-numbers
const scholarshipTypeIdList = [0, 1, 2, 3] as const;

// 奨学金種別
export type ScholarshipTypeId = (typeof scholarshipTypeIdList)[number];

export const isScholarshipTypeId = (
  value: unknown,
): value is ScholarshipTypeId => {
  if (typeof value !== 'number') {
    return false;
  }

  // eslint-disable-next-line no-magic-numbers
  if (value === 0) {
    return false;
  }

  return scholarshipTypeIdList.includes(value as ScholarshipTypeId);
};

const scholarshipTypeLabelList = [
  '----',
  '病院奨学金',
  '病院奨学金とその他',
  'その他',
] as const;

type ScholarshipTypeLabel = (typeof scholarshipTypeLabelList)[number];

type ScholarshipType = {
  id: ScholarshipTypeId;
  label: ScholarshipTypeLabel;
};

export const scholarshipTypeList: ScholarshipType[] = scholarshipTypeIdList.map(
  (value) => ({
    id: value,
    label: scholarshipTypeLabelList[value],
  }),
);

// eslint-disable-next-line no-magic-numbers, prefer-destructuring
export const defaultScholarshipType = scholarshipTypeList[0];

// eslint-disable-next-line no-magic-numbers
const borrowingPeriodIdList = [0, 1, 2, 3, 4, 5, 6] as const;

// 奨学金借入（予定）年数
export type BorrowingPeriodId = (typeof borrowingPeriodIdList)[number];

export const isBorrowingPeriodId = (
  value: unknown,
): value is BorrowingPeriodId => {
  if (typeof value !== 'number') {
    return false;
  }

  // eslint-disable-next-line no-magic-numbers
  if (value === 0) {
    return false;
  }

  return borrowingPeriodIdList.includes(value as BorrowingPeriodId);
};

const borrowingPeriodLabelList = [
  '----',
  '1年以下',
  '2年',
  '3年',
  '4年',
  '5年',
  '6年以上',
] as const;

type BorrowingPeriodLabel = (typeof borrowingPeriodLabelList)[number];

type BorrowingPeriod = {
  id: BorrowingPeriodId;
  label: BorrowingPeriodLabel;
};

export const borrowingPeriodList: BorrowingPeriod[] = borrowingPeriodIdList.map(
  (value) => ({
    id: value,
    label: borrowingPeriodLabelList[value],
  }),
);

// eslint-disable-next-line no-magic-numbers, prefer-destructuring
export const defaultBorrowingPeriod = borrowingPeriodList[0];
